<template>
  <div class="h-toolbarBg">
    <ejs-toolbar ref="toolBarFoNoRealTaskRight">
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Pm.establishTask")' :click="buttonClick" operate='create'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Pm.modifyTask")' :click="buttonClick" operate='modify'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Pm.delTask")' :click="buttonClick" operate='delete'></e-item>
        <e-item type='Separator'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("Pm.hangUpTask")' :click="buttonClick" operate='hungUp'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("Pm.activeTask")' :click="buttonClick" operate='active'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("Pm.dataMining")' :click="buttonClick" operate='upload'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-synchronize' :tooltipText='$t("System.reset")' :click="buttonClick" operate='reset'></e-item>
        <e-item type='Separator'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-task-tracking' :tooltipText='$t("Pm.checkUniformity")' :click="buttonClick" operate='consistency'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-sync-download' :tooltipText='$t("Pm.synchronousDownload")' :click="buttonClick" operate='sync'></e-item>
<!--        <e-item type='Separator'></e-item>-->
<!--        <e-item prefixIcon='icon hero-icon hero-icon-details' :tooltipText='$t("Pm.queryDetailInfo")' :click="buttonClick" operate='detail'></e-item>-->
      </e-items>
    </ejs-toolbar>
    <div class="h-inputBox-gnb">
      <div class="h-barSpace20"></div>
      <ejs-dropdownlist :dataSource="dataSourceOfSampleTime" :placeholder='$t("Pm.collectCycle")' :fields="fieldsOfSampleTime" class="e-input" ref="sampleTime" width="150" :change="sampleTimeChange"></ejs-dropdownlist>
    </div>

    <div class="h-inputBox-gnb">
      <div class="h-barSpace20"></div>
      <ejs-dropdownlist :dataSource="dataSourceOfReportTime" :placeholder='$t("Pm.reportCycle")' :fields="fieldsOfReportTime" class="e-input" ref="sampleTime" width="150" :change="reportTimeChange"></ejs-dropdownlist>
    </div>

    <div class="h-inputBox-gnb">
      <div class="h-barSpace20"></div>
      <ejs-dropdownlist :dataSource="dataSourceOfStatus" :placeholder='$t("Pm.taskStatus")' :fields="fieldsOfStatus" class="e-input" ref="taskSearchStatus" width="150" :change="taskStatusChange"></ejs-dropdownlist>
    </div>
  </div>
</template>

<script>
import {PmEventBus} from "../../../util/PmEventBus";

export default {
  name: 'PmNoRealTaskRightListToolbar',
  data() {
    return {
      taskSearchCycle: 0,
      taskSearchStatus: 3,
      fieldsOfSampleTime: {
        text: 'text',
        value: 'value'
      },
      fieldsOfReportTime: {
        text: 'text',
        value: 'value'
      },
      fieldsOfStatus: {
        text: 'text',
        value: 'value'
      },
      dataSourceOfSampleTime: [
        { text: `${this.$t('Pm.collectCycle')}-${this.$t('Pm.all')}`, value: 0 },
        { text: `${this.$t('Pm.collectCycle')}-${this.$t('Pm.fiveMinutes')}`, value: 300000 },
        { text: `${this.$t('Pm.collectCycle')}-${this.$t('Pm.fifteenMinutes')}`, value: 900000 },
        { text: `${this.$t('Pm.collectCycle')}-${this.$t('Pm.thirtyMinutes')}`, value: 1800000 },
        { text: `${this.$t('Pm.collectCycle')}-${this.$t('Pm.oneHour')}`, value: 3600000 },
        { text: `${this.$t('Pm.collectCycle')}-${this.$t('Pm.oneDay')}`, value: 86400000 },
      ],
      dataSourceOfReportTime: [
        { text: `${this.$t('Pm.reportCycle')}-${this.$t('Pm.all')}`, value: 0 },
        { text: `${this.$t('Pm.reportCycle')}-${this.$t('Pm.fiveMinutes')}`, value: 300000 },
        { text: `${this.$t('Pm.reportCycle')}-${this.$t('Pm.fifteenMinutes')}`, value: 900000 },
        { text: `${this.$t('Pm.reportCycle')}-${this.$t('Pm.thirtyMinutes')}`, value: 1800000 },
        { text: `${this.$t('Pm.reportCycle')}-${this.$t('Pm.oneHour')}`, value: 3600000 },
        { text: `${this.$t('Pm.reportCycle')}-${this.$t('Pm.oneDay')}`, value: 86400000 },
      ],
      dataSourceOfStatus: [
        { text: `${this.$t('Pm.taskStatus')}-${this.$t('Pm.all')}`, value: 3 },
        { text: this.$t('Pm.hangup'), value: 0 },
        { text: this.$t('Pm.active'), value: 1 },
        { text: this.$t('Pm.failure'), value: 2 }
      ],
    };
  },
  props: [
    'taskStatus' // 存放任务状态
  ],
  methods: {
    sampleTimeChange(args){
      PmEventBus.$emit("sampleTimeChange",args);
    },

    reportTimeChange(args){
      PmEventBus.$emit("reportTimeChange",args);
    },

    taskStatusChange(args){
      PmEventBus.$emit("taskStatusChange",args);
    },

    // 将工具栏的点击事件分发到父级组件的 methodList 方法中
    buttonClick(args) {
      this.$parent.methodList(args.item.operate);
    }
  },
  watch: {
    taskStatus(taskStatus){
      // 0 新增 1 修改 2 删除 | 4 挂起 5 激活 6 补采 7 重置 | 9 一致性检查 10 同步下载
      switch (taskStatus) {
        case 0: // 挂起
          this.$refs.toolBarFoNoRealTaskRight.enableItems([0, 1, 2, 3, 5, 6, 7, 8, 9], true);
          this.$refs.toolBarFoNoRealTaskRight.enableItems([4, 10], false);
          break;
        case 1: // 激活
          this.$refs.toolBarFoNoRealTaskRight.enableItems([0, 3, 4, 6, 7, 8, 9, 10], true);
          this.$refs.toolBarFoNoRealTaskRight.enableItems([1, 2, 5], false);
          break;
        case 2: // 失效
          this.$refs.toolBarFoNoRealTaskRight.enableItems([0, 2, 3, 8], true);
          this.$refs.toolBarFoNoRealTaskRight.enableItems([1, 4, 5, 6, 7, 9, 10], false);
          break;
        default:
          this.$refs.toolBarFoNoRealTaskRight.enableItems([0, 3, 8], true);
          this.$refs.toolBarFoNoRealTaskRight.enableItems([1, 2, 4, 5, 6, 7, 9, 10], false);
          break;
      }
    }
  }
};
</script>

<style>

</style>
